<template>
    <div class="CS2">
        <div class="CS2-minititle">ABOUT US</div>
        <div class="CS2-bigtitle">Full Stack Development Software Company</div>
        <div class="CS2-discription">(주)우스톤은 모바일 앱, 웹 소프트웨어 개발 및 라이브 쇼핑 플랫폼을 주력
            사업으로 다양한 앱, 웹 아웃소싱 개발경험을 가지고 있는 스타트업 기업으로 현재는 라이브 커머스 플랫폼 사업으로
            영역을 확대하고 있습니다
        </div>
        <div class="CS2-cont">
            <div class="CS2-contbox">
                <div class="contbox-img">
                    <img src="@/assets/CS2-1.png" alt="">
                </div>
                <div class="contbox-title">SERVICE</div>
                <div class="contbox-description">사람에 대한 이해와 공감으로부터 문제를 발견합니다</div>
            </div>
            <div class="CS2-contbox">
                <div class="contbox-img">
                    <img src="@/assets/CS2-2.png" alt="">
                </div>
                <div class="contbox-title">WORK</div>
                <div class="contbox-description">비지니스와 기술에 대한 통찰력 있는 이해로부터 해법을 찾아냅니다</div>
            </div>
            <div class="CS2-contbox">
                <div class="contbox-img">
                    <img src="@/assets/CS2-3.png" alt="">
                </div>
                <div class="contbox-title">STORY</div>
                <div class="contbox-description">실패로부터 배우고 지식을 공유하여 모두의 경험을 확장합니다</div>
            </div>
            <div class="CS2-contbox">
                <div class="contbox-img">
                    <img src="@/assets/CS2-4.png" alt="">
                </div>
                <div class="contbox-title">PEOPLE</div>
                <div class="contbox-description">좋은 사람들과 함께하는 우리들의 시간을 소개합니다</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "CompanySlide2",
      
    }
</script>
<style lang="scss" scoped>
    .CS2 {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        // background-color: #f4f4f4;
        padding: 80px 0px 80px 0px;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
            .CS2-minititle {
                font-size: 24px;
                color: #a1a1a1;
                margin-bottom: 10px;
            }
            .CS2-bigtitle {
                font-size: 40px;
                font-weight: 900;
                color: #00a79d;
                margin-bottom: 20px;
            }
            .CS2-discription {
                width: 1000px;
                font-size: 20px;
                color: #a1a1a1;
                text-align: center;
                line-height: 36px;
            }
            .CS2-cont {
                width: 1400px;
                padding-top: 50px;
                box-sizing: border-box;
                margin: auto;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .CS2-contbox {
                width: 16%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
                .contbox-img {
                    width: 100%;
                    position: relative;
                    margin-bottom: 60px;
                    img{
                        width: 100%;
                        object-fit: contain;
                    }
                }
                .contbox-title {
                    font-size: 24px;
                    font-weight: 900;
                    color: #00a79d;
                    margin-bottom: 15px;
                }
                .contbox-description {
                    font-size: 18px;
                    color: #a1a1a1;
                    text-align: center;
                    line-height: 25px;
                }
            }
    }
</style>